export default function ProblemsSolved() {
  const problems = [
    { icon: 'ri-share-forward-line', title: 'Делегирование', desc: 'Как передавать задачи, сохраняя контроль над результатом и не скатываясь в микроменеджмент' },
    { icon: 'ri-task-line', title: 'Постановка задач', desc: 'Чёткие критерии, сроки и форматы отчётности — чтобы задачи выполнялись с первого раза' },
    { icon: 'ri-check-double-line', title: 'Контроль исполнения', desc: 'Система промежуточных точек контроля без тотальной слежки за каждым шагом' },
    { icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Развивающая обратная связь, которая мотивирует, а не демотивирует сотрудников' },
    { icon: 'ri-team-line', title: 'Управление командой', desc: 'Распределение ролей, формирование ответственности и командное взаимодействие' },
    { icon: 'ri-fire-line', title: 'Мотивация сотрудников', desc: 'Материальная и нематериальная мотивация: как зажечь команду на достижение целей' },
    { icon: 'ri-scales-3-line', title: 'Управление конфликтами', desc: 'Алгоритмы разрешения конфликтов между сотрудниками, отделами и уровнями управления' },
    { icon: 'ri-lightbulb-flash-line', title: 'Принятие решений', desc: 'Методы анализа альтернатив и принятия решений в условиях неопределённости' },
    { icon: 'ri-emotion-line', title: 'Эмоциональный интеллект', desc: 'Управление эмоциями — своими и команды — в стрессовых и кризисных ситуациях' },
    { icon: 'ri-star-line', title: 'Лидерство', desc: 'Как стать лидером, за которым идут добровольно, а не начальником, которого боятся' },
    { icon: 'ri-refresh-line', title: 'Управление изменениями', desc: 'Внедрение новых процессов, технологий и подходов без сопротивления команды' },
    { icon: 'ri-chat-3-line', title: 'Коммуникация', desc: 'Выстраивание эффективных коммуникаций внутри команды и между подразделениями' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие задачи решает тренинг для руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Каждая из этих задач прямо влияет на эффективность команды и бизнес-результаты компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {problems.map((item, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group flex items-start gap-4">
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1.5 text-sm">{item.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}